import * as React from 'react';
import { useActor } from '@xstate/react';
import { useQuery } from 'react-query';
import { getLeadTypes } from '~/api/routes/leadad/options';
import { SubscriptionActor } from './machine/subscription';
import Selector, { SelectorProps } from './Selector';

interface TypeSelectorProps extends SelectorProps {
  subscriptionRef: SubscriptionActor;
}

// TODO: For some reason, Omit does not work here. We will need to resolve this
function TypeSelector(props: Omit<TypeSelectorProps, 'options'>) {
  const {
    subscriptionRef,
    ...selectProps
  } = props;

  const [subscriptionState] = useActor(subscriptionRef);

  const query = useQuery(['leadad', 'types'], getLeadTypes, {
    initialData: ['Buyer'],
  });

  return (
    <Selector
      isLoading={query.isLoading || !subscriptionState.matches('subscription.idle')}
      options={query.data}
      {...selectProps}
    />
  );
}

export default React.memo(TypeSelector);
